import { isProduction } from '../environment';
import KanbanAPI from './kanban-api';
import MockKanbanAPI from './mock-kanban-api';

export default isProduction() ? KanbanAPI : MockKanbanAPI;

//export default MockKanbanAPI;